import React from "react";
import EditableTableComponent from "../../../Components/Table/EditableTable";

const KeyFactors = () => {
  const columns = [
    { header: "Add Text", accessor: "segment", width: "100px" },
    { header: "Add Text", accessor: "insight", align: "left", width: "250px" },
  ];

  const initialData = [
    {
      segment: "Add Text",
      insight: "Add Text​",
    },
    {
      segment: "Add Text",
      insight: "Add Text​​",
    },
    {
      segment: "Add Text",
      insight: "Add Text​​",
    },
    {
      segment: "Add Text",
      insight: "Add Text​",
    },
    {
      segment: "Add Text",
      insight: "Add Text​",
    },
  ];

  return (
    <div>
      <EditableTableComponent
        columns={columns}
        initialData={initialData}
        heading={"Key Factors"}
      />
    </div>
  );
};

export default KeyFactors;
